<template>
  <div>
    <div class="grayBg">
      <ul class="w1200 index">
        <li>
          <a href="/">中企门户</a>&nbsp;>&nbsp;</li>
        <li>
          <a href="/domain">企业域名</a>&nbsp;>&nbsp;</li>
        <li>
          <a href="">域名介绍</a>
        </li>
      </ul>
      <div class="w1200 domain-intro">
        <div class="intro-left">
          <div class="left-com">

            <!-- 域名标题 -->
            <div class="clearfix">
              <div class="leftcombox">.{{pageData.name}}</div>
              <ul>
                <li>{{pageData.title}}</li>
                <li>¥
                  <span>{{pageData.price}}</span> /首年</li>
                <li>
                  <a href="javascript:;"
                     @mouseenter="getDomainGoodsPriceList(pageData)">查看更多价格

                    <div class="domain-list">
                      <div class="item">
                        <div class="more-price">
                          <div class="more-price-list "
                               v-if="pageData.morePrice">
                            <!-- {{item.morePrice}} -->
                            <table>
                              <tr>
                                <th></th>
                                <th>一年</th>
                                <th>三年</th>
                                <th>五年</th>
                                <th>十年</th>
                              </tr>
                              <tr>
                                <td>新注</td>
                                <td v-for="(price,i) in pageData.morePrice "
                                    :key="i ">{{price.newGoodsSheetModel&&price.newGoodsSheetModel.payPrice}}元</td>
                              </tr>
                              <tr>
                                <td>续费</td>
                                <td v-for="(price,i) in pageData.morePrice "
                                    :key="i ">{{price.renewGoodsSheetModel&&price.renewGoodsSheetModel.payPrice}}元</td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                  </a>

                </li>
              </ul>
            </div>

            <!-- 域名简介 -->
            <p class="intro"
               v-html="pageData.intro">

            </p>
            <div class="yheader">
              <input type="text"
                     v-model="domainName"
                     placeholder="注册域名请先查询，例如输入：300">
              <!-- 搜索框后缀 -->
              <div class="combtn">.{{pageData.name}}</div>
              <button @click="query">查询域名</button>
            </div>
          </div>
        </div>
        <div class="intro-right">
          <!-- <h3>英文域名</h3>
          <section>
            <a :href="'/domain/info-intro/en/'+item"
               v-for="(item,index) in domaininfoen"
               :key="index"
               @click="change('net')">
              <span :class="{ymbtn:$route.params.suffix===item&&$route.params.lang==='en'}">.{{item.replace('-','.')}}</span>
            </a>
          </section>
          <h3>中文域名</h3>
          <section>
            <a :href="'/domain/info-intro/cn/'+item"
               v-for="(item,index) in domaininfocn"
               :key="index"
               @click="change('net')">
              <span :class="{ymbtn:$route.params.suffix===item&&$route.params.lang==='cn'}">.{{item.replace('-','.')}}</span>
            </a>
          </section> -->
        </div>
      </div>
      <div class="DgrayBg">

        <!-- 域名四大特点-->
        <div class="w1200 pinpai">
          <h2>.{{pageData.name}}域名</h2>
          <p>{{pageData.subHead}}</p>
          <ul>
            <li>
              <b>全球流行</b>
              <p>{{pageData.featureFir}}</p>
            </li>
            <li>
              <b>广泛应用</b>
              <p>{{pageData.featureSec}}</p>
            </li>
            <li>
              <b>{{pageData.ppxcName}}</b>
              <p>{{pageData.featureThi}}</p>
            </li>
            <li>
              <b>{{pageData.zdxlName}}</b>
              <p>{{pageData.featureFour}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="grayBg pb30">
        <div class="w1200 youshi">
          <h2>中企优势</h2>
          <ul>
            <li>
              <b>5倍故障时长赔偿</b>
              <div>
                <span>5倍赔付终端服务的时间</span>
              </div>
            </li>
            <li>
              <b>五星级认证域名服务商</b>
              <div>
                <span>荣获ICANN和CNNIC双重认证的顶级域名注册服务商</span>
              </div>
            </li>
            <li>
              <b>7X24小时售后支持</b>
              <div>
                <span>解决企业最后一公里问题，售后长期稳定无忧</span>
              </div>
            </li>
            <li>
              <em>
                <i>1999</i>
              </em>
              <b>中企动力成立，至今{{company_years}}年</b>
            </li>
            <li>
              <em>
                <i>{{company_num}}</i>
                <strong>+</strong>
              </em>
              <b>{{company_num}}家分公司，专属管家式服务</b>
            </li>
            <li>
              <em>
                <i>{{kehu_num}}</i>
                <strong>+</strong>万</em>
              <b>{{kehu_num}}万企业客户的共同选择</b>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from './components/header'

import recommend from './components/recommend'
import cTitle from './components/title'
import infoIntro from '../static/assets/info-intro'
import domaininfoen from '../static/assets/domain-infoen'
import domaininfocn from '../static/assets/domain-infocn'
import infoIntroData from '../static/assets/info-intro-data'


// const len = infoIntro.name.length
// const keys = Object.keys(infoIntro)
// const arr = []
// for (let i = 0; i < len; i++) {
//   const obj = {}
//   keys.forEach(v => {
//     obj[v] = infoIntro[v][i][v]
//   })
//   arr.push(obj)
// }
export default {
  data () {
    return {
      kehu_num:kehu_num,
      company_years:company_years,
      company_num :company_num,
      // designer_num:designer_num,
      domainName: '',
      pageData: {},
      isShowMore: false,
      infoIntroData: infoIntroData,
      domaininfoen: domaininfoen.map(v => v.replace('.', '-')),
      domaininfocn: domaininfocn.map(v => v.replace('.', '-'))
    }
  },
  components: {
    banner,
    recommend,
    cTitle
  },
  watch: {
    $route: function (route) {
      this.change(route.params)
    }
  },
  methods: {
    change (data) {
      this.pageData = this.getData(data.suffix, data.lang) || {}
    },
    getData (name, lang) {
      name = name.replace('-', '.')
      return this.infoIntroData.filter(v => v.name === name && v.lang === lang)[0] || this.infoIntroData.filter(v => v.name === name && v.lang === 'en')[0]
    },
    getDomainGoodsPriceList (item, i) {

      if (item.morePrice) {
        return
      }
      $.get(
        `/domain/getDomainGoodsPriceList?domainName=${
        this.$route.query.lang === 'cn' ? '中文' : 'en'
        }&domainSuffix=.${item.name}`
      ).then(response => {
        this.$set(item, 'morePrice', response.goodsPriceMapList)
      })
    },
    query () {
      const reg = new RegExp(
        '^[A-Za-z０１２３４５６７８９－0-9-Ａ-Ｚａ-ｚ\u4e00-\u9fa5]+$'
      )
      if (!this.domainName) {
        this.$msgbox({
          type: 'error',
          message: '请填写一个域名'
        })
        return
      }

      if (!reg.test(this.domainName) || this.domainName.length > 63) {
        if (this.language === 'zh-CN') {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            // type: 'error',
            message:
              '提示：中文域名至少需要含有一个中文文字，可以包含中文、字母a-z(大小写等价)、数字0-9或者半角的连接符“-”，“-”不能放在开头或者结尾，输入内容不能超过63个字符，最多可以注册19个汉字。'
          })
        } else {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            // type: 'error',
            message:
              '提示：域名可由英文字母（a-z,不区分大小写）、数字（0-9）、连字符“-”（即中横线）,不能使用空格及特殊字符（如！、$、&、？等），“-”不能单独填写或连续使用，不能放在开头或结尾，输入内容不能超过63个字符。'
          })
        }

        return
      }

      this.$router.push({
        path: `/domain/result?domainName=${this.domainName.toLowerCase()}&domainSuffixs=.${
          this.pageData.name
          }`
      })
    }
  },
  created () {
    this.change({
      lang: this.$route.params.lang || 'en',
      suffix: this.$route.params.suffix || 'com'
    })
  }
}
</script>
<style  lang="scss">
@import "../static/css/info-intro.scss";
</style>



// WEBPACK FOOTER //
// src/info-intro.vue